const UTC_TZ_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}([-+]\d{2}:\d{2}|Z)/;

export default UTC_TZ_REGEX;
